<template>
  <base-overlay :show="loading">
    <b-card v-if="loading" />
    <b-row v-else>
      <b-col
        v-for="(el, ix) in data"
        :key="ix"
        sm="12"
        md="6"
      >
        <stats-card
          :data="el"
          :service-type="serviceType"
          @refetch="fetch"
        />
      </b-col>
    </b-row>
  </base-overlay>
</template>

<script>
import { ref } from '@vue/composition-api'
import { BCol, BRow, BCard } from 'bootstrap-vue'
import StatsCard from './StatsCard.vue'
import snakeCaseToCamelCase from '@/utils/snake-case-to-camcel-caase'

export default {
  components: {
    BCol,
    BRow,
    BCard,
    StatsCard,
  },
  props: {
    serviceType: {
      type: String,
      default: undefined,
    },
  },
  setup(props, { root }) {
    const loading = ref(false)
    const data = ref([])
    const fetch = async () => {
      loading.value = true
      const res = await root.$store.dispatch('trips/fetchNoDriverFoundAndCanceledStats', {
        serviceType: props.serviceType,
      })
      data.value = res.aggregations.trip_state.buckets.map(el => ({
        ...el,
        label: snakeCaseToCamelCase(el.key),
      }))
      loading.value = false
    }
    fetch()
    return {
      fetch,
      data,
      loading,
    }
  },
}
</script>

<style>

</style>
